import React from 'react';

import HealthDataTable from './HealthDataTable';
import ReportDialog from '../../error-reports/view/ReportDialog';

const HealthScreen = () => (
  <div>
    <HealthDataTable/>
    <ReportDialog/>
  </div>
);

export default HealthScreen;